import React, { Component } from "react";
import ReactGA from "react-ga";
import BannerImg from "../../assets/images/banner/contact-us.png";
import { Helmet } from "react-helmet";
import ContactForm from "../../components/form/contact-form";
import ContactInfo from "../../components/form/contact-info";
//import Iframe from "react-iframe";

class ContactUs extends Component {
  state = {};
  render() {
    ReactGA.initialize("UA-5235714-2");
    ReactGA.pageview(window.location.pathname + window.location.search);
    return (
      <React.Fragment>
        <Helmet defer={false}>
          <title>Contact Avani Cimcon | Talk to Us About Modernization, AI & Delivery</title>
          <meta
            name="keywords"
            content="contact avani cimcon, talk to us, enterprise software engineering, legacy modernization, managed services, dedicated engineering teams, enterprise ai enablement, it consulting services"
          />
          <meta
            name="description"
            content="Contact Avani Cimcon to discuss enterprise software engineering, managed services, legacy modernization and AI enablement."
          />
          <link rel="canonical" href="https://www.avanicimcon.com/contact-us" />
        </Helmet>
        <div className="page-banner d-flex align-items-center justify-content-center text-white">
          <div className="page-title container position-relative">
            <h1 className="font-weight-bold text-uppercase">Talk to Us</h1>
            <h5>Start a conversation about enterprise software, modernization and AI</h5>
          </div>
          <div
            className="page-banner-img"
            style={{ backgroundImage: `url("${BannerImg}")` }}
          ></div>
          <div className="page-banner-overlay"></div>
        </div>

        <div className="inner-page mt-5 mb-5 ">
          <div className="container">
            <div className="row">
              <div className="col-lg-6">
                <div className="shadow-sm p-4">
                  <h5 className="text-primary mb-4">India Office</h5>
                  <p>
                    <b>Tel :</b> 91-79-26872171 / 049 (9:00 AM to 6:00 PM, IST)
                  </p>
                  <p className="mb-0">
                    <b>Email :</b>{" "}
                    <a href="mailto:inquiry@avanicimcon.com" className="text-primary">
                      inquiry@avanicimcon.com
                    </a>
                  </p>
                </div>
              </div>
              <div className="col-lg-6">
                <ContactInfo />
              </div>
            </div>

            <div className="row mt-4">
              <div className="col-lg-12">
                <ContactForm />
                {/* <Iframe
                  url="http://travel.avanicimcon.com/InquiryForm.asp"
                  width="100%"
                  height="550px"
                  id="myId"
                  className="myClassname mt-4"
                  display="initial"
                  position="relative"
                  frameBorder="0"
                /> */}
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default ContactUs;
